var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg500(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 984,
    height: 638,
    viewBox: "0 0 984 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.289 508.921C242.364 508.921 314.739 465.172 314.739 372.273C314.739 291.797 253.166 250.749 176.471 250.749C165.129 250.749 149.466 251.829 138.123 254.53L141.364 194.038H295.295V116.262H60.8878L51.706 335.006C78.7114 325.284 118.139 318.263 145.145 318.263C182.412 318.263 223.46 331.225 223.46 376.594C223.46 413.322 196.995 432.226 166.209 432.226C136.503 432.226 112.738 412.782 104.637 386.316L22 411.701C39.8236 472.194 97.6152 508.921 167.289 508.921Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.557 508.921C605.579 508.921 646.627 414.942 646.627 306.38C646.627 198.359 605.579 106 497.557 106C388.995 106 347.407 198.359 347.407 306.38C347.407 414.942 388.995 508.921 497.557 508.921ZM497.557 431.145C449.487 431.145 440.306 355.53 440.306 306.38C440.306 258.311 449.487 182.695 497.557 182.695C545.087 182.695 553.728 258.311 553.728 306.38C553.728 355.53 545.087 431.145 497.557 431.145Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.723 508.921C927.745 508.921 968.793 414.942 968.793 306.38C968.793 198.359 927.745 106 819.723 106C711.161 106 669.573 198.359 669.573 306.38C669.573 414.942 711.161 508.921 819.723 508.921ZM819.723 431.145C771.654 431.145 762.472 355.53 762.472 306.38C762.472 258.311 771.654 182.695 819.723 182.695C867.253 182.695 875.895 258.311 875.895 306.38C875.895 355.53 867.253 431.145 819.723 431.145Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.43 521.772C864.037 521.772 865.341 520.469 865.341 518.861C865.341 517.253 864.037 515.95 862.43 515.95C860.822 515.95 859.519 517.253 859.519 518.861C859.519 520.469 860.822 521.772 862.43 521.772Z",
    fill: "#92D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4225 538.096C93.8558 538.096 95.8284 536.123 95.8284 533.69C95.8284 531.257 93.8558 529.284 91.4225 529.284C88.9892 529.284 87.0166 531.257 87.0166 533.69C87.0166 536.123 88.9892 538.096 91.4225 538.096Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.479 82.2073C773.912 82.2073 775.885 80.2347 775.885 77.8014C775.885 75.3681 773.912 73.3955 771.479 73.3955C769.046 73.3955 767.073 75.3681 767.073 77.8014C767.073 80.2347 769.046 82.2073 771.479 82.2073Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.046 45.269L593.258 51.3861L582.046 57.5229L575.929 68.7343L569.792 57.5229L558.581 51.3861L569.792 45.269L575.929 34.0576L582.046 45.269Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.485 545.211L957.696 551.348L946.485 557.485L940.348 568.677L934.211 557.485L923 551.348L934.211 545.211L940.348 534L946.485 545.211Z",
    fill: "#92D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.333 199.666C394.638 199.666 408.666 185.638 408.666 168.333C408.666 151.028 394.638 137 377.333 137C360.028 137 346 151.028 346 168.333C346 185.638 360.028 199.666 377.333 199.666Z",
    fill: "#91D6DB",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.625 92.5853C346.221 92.5853 362.917 75.8888 362.917 55.2926C362.917 34.6965 346.221 18 325.625 18C305.029 18 288.332 34.6965 288.332 55.2926C288.332 75.8888 305.029 92.5853 325.625 92.5853Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.547 453.423L430.771 346.521C425.874 339.421 416.177 337.572 409.017 342.391C402.33 346.954 400.205 355.844 404.1 362.945L355.124 393.491C331.659 408.203 322.552 437.923 333.724 463.257C261 494 212.135 497.092 175 480C139.045 463.38 113.627 426.279 78.5369 372.189C53.1047 333.008 30.2492 308.103 -5.58789 284.5V314.539C19.3132 334.582 40.7919 358.539 58.0023 385.486C95.3736 443.155 123.107 482.395 165.022 501.789C183.413 510.089 203.396 514.22 223.577 513.905C257.309 513.905 297.257 504.189 346.351 484.52L349.145 489.004C365.45 514.967 399.674 522.874 425.716 506.706L479.413 473.269C484.606 478.579 494.204 480.212 500.557 475.885C507.677 471.007 508.386 460.602 503.547 453.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.534 430.566C462.534 430.566 393.24 480.565 365.86 485.384C356.026 487.115 345.66 483.417 333.938 461.545C333.938 461.545 354.511 516.205 393.83 515.595C397.764 515.595 412.693 514.75 418.475 511.662C430.906 504.935 488.556 468.881 488.556 468.881L462.534 430.566Z",
    fill: "#92D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.811 349.451C404.811 349.451 411.203 342.704 417.163 347.956C423.122 353.208 499.537 463.787 499.537 463.787C499.537 463.787 505.103 473.091 497.944 477.418C497.944 477.418 507.346 472.088 507.385 462.706C507.424 453.323 487.381 428.717 487.381 428.717L431.777 345.95C431.777 345.95 415.648 332.555 404.811 349.451Z",
    fill: "#92D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.244 363.632C401.467 358.44 402.982 347.897 410.102 343.078C417.222 338.338 426.841 340.167 431.738 347.189L504.514 454.11C509.333 461.25 507.484 470.947 500.403 475.845C493.283 480.683 485.5 479.5 480.5 474",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.775 503.205C400.775 503.205 410.787 506.391 426.345 495.79C441.903 485.188 481.792 459.067 481.792 459.067",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.542 358.44L356.265 394.179C330.322 410.484 322.415 444.709 338.563 470.751L350.364 489.613C366.67 515.576 400.894 523.483 426.936 507.315L488.599 468.843L413.542 358.44Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86 554.954C188.86 554.954 208.982 557.55 207.349 571.161C205.717 584.772 188.86 599.839 188.86 599.839C188.86 599.839 221.098 586.071 225.032 568.368C225.032 568.408 228.179 545.1 188.86 554.954Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.631 552.869C347.631 552.869 378.354 555.918 376.662 575.863C375.502 589.513 358.96 603.163 358.96 603.163C358.96 603.163 390.313 590.851 394.365 573.109C394.365 573.109 397.492 550.903 347.631 552.869Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.794 530.722C551.794 530.722 591.683 535.049 588.693 562.389C586.726 580.327 567.529 588.608 567.529 588.608C567.529 588.608 616.092 582.137 616.092 561.307C616.092 550.941 601.36 536.386 551.794 530.722Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.441 534.435C727.441 534.435 771.441 545.076 766.78 564.646C762.57 582.211 735.152 580.775 735.152 580.775C735.152 580.775 783.813 587.915 783.99 567.007C784.069 559.572 776.299 544.584 727.441 534.435Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M616.071 561.254C616.299 544.69 582.778 530.797 541.199 530.223C499.619 529.649 465.728 542.612 465.499 559.176C465.27 575.74 498.792 589.634 540.371 590.208C581.95 590.781 615.842 577.819 616.071 561.254Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M912.019 606.353C905.366 617.657 881.703 613.98 859.138 598.137C836.574 582.294 823.847 561.303 830.499 549.999",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M188.022 601.13C213.041 590.291 229.392 572.431 224.543 561.237C219.694 550.043 195.481 549.755 170.462 560.593C145.442 571.431 129.091 589.292 133.94 600.486C138.789 611.68 163.003 611.968 188.022 601.13Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M341.456 608.534C373.799 601.097 397.301 583.25 393.949 568.672C390.597 554.094 361.66 548.304 329.317 555.742C296.973 563.179 273.471 581.026 276.824 595.604C280.176 610.182 309.113 615.971 341.456 608.534Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M784.126 569.218C786.724 557.299 764.56 542.346 734.62 535.819C704.681 529.291 678.303 533.662 675.705 545.58C673.106 557.499 695.271 572.452 725.21 578.979C755.15 585.507 781.527 581.136 784.126 569.218Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.233 442.25L506.238 399.903",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.609 393.884L527.521 378.778",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.035 393.825L543.415 451.849",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.35 387.786L572.84 427.36",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.489 419.394V400.531",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.076 303.581L450.595 330.488",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.115 319.651L457.736 256.042",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.746 273.172L477.307 316.857",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.588 141.115C951.982 142.806 909.555 132.185 869.273 122.075C833.692 113.145 800.097 104.707 770.377 107.048C743.882 108.818 718.234 117.197 695.811 131.438C676.28 144.026 658.833 159.604 644.14 177.601C636.666 186.924 629.723 196.641 623.33 206.731C599.57 194.339 570.421 199.847 552.817 220.047L520 255L538.104 272.19L498.156 316.898L551.066 364.103L591.486 318.864L608.716 333.951L640.679 297.897C659.659 276.497 658.932 244.023 641.937 222.191C647.425 213.517 655.312 204.489 663.436 194.654C695.634 155.906 732.238 134.644 772.344 131.438C797.913 129.471 829.679 137.338 863.254 145.796C897.616 154.411 935.066 163.833 974.562 165.347C978.181 165.485 981.82 165.563 985.478 165.563C988.822 165.563 992.166 165.563 995.529 165.347L995.588 141.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.41 205.806C629.449 196.503 636.018 187.534 643.079 178.958C657.772 160.764 675.219 144.97 694.789 132.145C717.133 117.492 742.782 108.641 769.414 106.379C799.036 104.038 832.65 112.476 868.232 121.406C897.302 128.703 927.495 136.276 958.473 139.285",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.266 318.393L546 368L493.09 320.755L537.179 271.345",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.266 318.393L546 368L493.09 320.755L537.179 271.345",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.065 272.721L529.206 281.734L581.403 327.248L589.263 318.235L537.065 272.721Z",
    fill: "#92D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.627 312.749C585.627 312.749 617.904 276.086 628.093 263.379C635.35 254.332 649.453 234.722 639.206 218.298C639.206 218.298 669.417 252.62 644.398 289.775C634.033 305.157 607.46 332.025 607.46 332.025L585.627 312.749Z",
    fill: "#92D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.092 319.889L639.599 287.16C639.599 287.16 654.35 269.871 647.053 250.812",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.154 215.8C636.154 215.8 658.872 178.429 695.889 151.148C721.322 131.951 752.281 121.526 784.145 121.428C825.194 121.015 878.065 141.648 891.754 146.585C929.244 159.96 945.431 163.107 910.027 156.419C842.5 139.5 805.525 132.679 805.525 132.679C805.525 132.679 750.156 124.614 712.333 148.965C674.509 173.315 641.996 222.173 641.996 222.173L636.154 215.8Z",
    fill: "#92D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.513 164.897C941.005 164.897 899.799 154.551 862.29 145.228C828.715 136.75 796.988 128.745 771.359 130.85C731.195 134.056 694.532 155.318 662.373 194.105C655.036 203.094 648.211 212.496 641.917 222.232",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.658 333.243L639.62 297.209C661 272.938 658.797 235.96 634.663 214.403C610.392 193.022 573.414 195.225 551.856 219.359L519.383 255.983L543.635 277.206L607.658 333.243Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.943 320.262L545.775 367.586",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.763 73.9255C201.946 73.9255 204.526 71.3453 204.526 68.1625C204.526 64.9796 201.946 62.3994 198.763 62.3994C195.58 62.3994 193 64.9796 193 68.1625C193 71.3453 195.58 73.9255 198.763 73.9255Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.837 100.458C344.204 100.458 361.526 83.1366 361.526 61.7692C361.526 40.4018 344.204 23.0801 322.837 23.0801C301.469 23.0801 284.147 40.4018 284.147 61.7692C284.147 83.1366 301.469 100.458 322.837 100.458Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.247 70.935C270.85 80.9269 262.156 88.8142 263.611 91.2925C265.893 95.2264 293.607 83.6609 325.51 65.3293C357.413 46.9977 381.41 28.9415 379.128 24.9486C377.653 22.4113 366.441 25.9321 349.624 33.8587",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.529 77.6031C274.233 86.9852 267.86 93.3383 269.158 95.62C271.44 99.5538 299.154 87.9883 331.057 69.6764C362.96 51.3645 386.976 33.2689 384.675 29.2957C383.141 26.6207 371.988 30.1022 353.972 38.7959",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M628.672 132.344C640.089 132.344 649.345 123.089 649.345 111.672C649.345 100.255 640.089 91 628.672 91C617.255 91 608 100.255 608 111.672C608 123.089 617.255 132.344 628.672 132.344Z",
    fill: "#91D6DB",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2236 625.332C86.3168 574.044 165.254 532.404 261 506.64",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 329C9 329 25.1877 335.353 59.1562 379.117C93.1248 422.881 122.097 479.233 167.651 496.817C213.205 514.401 258.631 506.989 342.5 479L346.5 485.5C346.5 485.5 276.028 513.85 237.594 514.283C199.161 514.716 163.56 516.388 122.235 472.545C99.9106 448.726 80.1038 422.664 63.1491 394.754C63.1491 394.754 40.1362 358.779 9 329Z",
    fill: "#92D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.5 485C298.17 504.827 258.586 514.396 224.756 514.396C204.575 514.711 183.891 511.801 165.5 503.5C123.585 484.107 95.9106 443.67 58.5 386C46.5 370 32 349 11 330.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 319C50.6794 335.64 65.5099 354.011 78.2752 373.818C113.385 427.908 139.072 464.591 175.027 481.211C212.536 498.559 261.115 493.248 334.5 464",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.5 626.5C855.776 543.498 740.255 500.171 580 484.796",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.22 306.38C638.22 336.816 634.994 366.106 627.97 392.5M339 306.38C339 266.916 344.551 229.543 356.89 198M431.899 306.38C431.899 258.311 441.081 182.695 489.15 182.695C513.386 182.695 526.976 201.856 535 227.5M420.11 122C439.231 111.728 462.114 106 489.15 106C510.4 106 529.058 109.574 545.321 116.138M342.94 361.5C344.558 372.183 346.69 382.547 349.366 392.5M464.5 507.5C490.167 512.333 550.8 511.3 588 468.5C591.042 465 606 447 614.5 429",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661 306.38C661 244.457 681.5 184.5 700.5 158M753.899 306.38C753.899 258.311 763.081 182.695 811.15 182.695C858.68 182.695 867.321 258.311 867.321 306.38C867.321 355.53 858.68 431.145 811.15 431.145C778.218 431.145 763.538 395.656 757.558 357.5M664.94 361.5C677.568 444.9 721.547 508.921 811.15 508.921C855.729 508.921 888.902 492.915 912.491 466.484M949.97 392.5C956.994 366.106 960.22 336.816 960.22 306.38C960.22 281.064 957.966 256.608 953.123 234",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 193.5C937.667 185.5 930.5 168 920 158",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8878 116.262H286.295V194.037H132.364L129.123 254.529C140.466 251.829 156.129 250.749 167.471 250.749C188.82 250.749 208.997 253.929 227 260.255M50 335.5C77.0054 325.778 109.139 318.262 136.145 318.262C173.412 318.262 214.46 331.225 214.46 376.594M292.808 315C301.109 331.104 305.739 350.207 305.739 372.273C305.739 429.812 278.974 468.388 240 489.5M50.5 151.5L45.2546 275M193.912 421C183.857 428.451 170.964 432.225 157.209 432.225C127.503 432.225 102.738 411.281 94.6366 384.816L87.5 387M56.5 394.799L12 408C29.8236 468.492 88.6152 508.921 158.289 508.921C169.5 508.921 174 507.5 174 507.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5 267.5C254 272 270 284 282 298",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 984,
    height: 638,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.7abbe53141dab22a97b5487bf96218c8.svg";
export { ForwardRef as ReactComponent };